// src/api/integrations.js
// Compat layer: non crasha se Core non è pronto e normalizza i payload.

import sdkDefault, * as sdk from '@base44/sdk'
import { Core as ForwardCore, Integrations as ForwardIntegrations } from '@/integrations/Core'

// Prende Core da dove capita (named, default, globali)
const pickCore = () => {
  const w = typeof window !== 'undefined' ? window : {}
  return (
    (sdk && sdk.Integrations && sdk.Integrations.Core) ||
    (sdkDefault && sdkDefault.Integrations && sdkDefault.Integrations.Core) ||
    (sdk && sdk.Core) ||
    (sdkDefault && sdkDefault.Core) ||
    (ForwardIntegrations && ForwardIntegrations.Core) ||
    ForwardCore ||
    (w.Integrations && w.Integrations.Core) ||
    w.Core ||
    null
  )
}
let Core = pickCore()

// -------- Fallback locali --------
const Fallback = {
  UploadFile: async (file) => {
    const blob = file instanceof Blob ? file : new Blob([String(file ?? '')], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    return { ok: true, url, file_url: url }
  },
  InvokeLLM: async ({ prompt, model = 'local-stub', temperature = 0.2 } = {}) =>
    ({ ok: true, content: '🤖 (stub) Risposta simulata', model, temperature, prompt }),
  SendEmail: async () => ({ ok: true }),
}

// Helper normalizza parametri e risposta
const call = (name, fb) => {
  const fn = Core && typeof Core[name] === 'function' ? Core[name] : fb
  return async (arg) => {
    const input = (arg && typeof arg === 'object' && 'file' in arg) ? arg.file : arg
    const res = await fn(input)
    // Normalizzazione URL per upload
    if (name === 'UploadFile' || name === 'UploadPrivateFile') {
      const url =
        (res && (res.file_url || res.url || res.link || res.publicUrl)) || ''
      return { ...res, url, file_url: url }
    }
    return res
  }
}

// Esporti usati dalla UI
export const UploadFile = call('UploadFile', Fallback.UploadFile)
export const UploadPrivateFile = call('UploadPrivateFile', Fallback.UploadFile)
export const InvokeLLM = call('InvokeLLM', Fallback.InvokeLLM)
export const SendEmail = call('SendEmail', Fallback.SendEmail)

// Alias “parlanti” spesso presenti
export const GenerateImage = async (promptOrObj) => {
  const args = typeof promptOrObj === 'string' ? { prompt: promptOrObj } : (promptOrObj || {})
  return InvokeLLM(args)
}
export const CreateFileSignedUrl = async () => ({ ok: true, url: '' })
export const ExtractDataFromUploadedFile = async (file) => ({
  ok: true,
  name: file?.name || 'file',
  size: file?.size || 0,
  type: file?.type || 'application/octet-stream',
})

// Default export
export default {
  UploadFile,
  UploadPrivateFile,
  CreateFileSignedUrl,
  ExtractDataFromUploadedFile,
  GenerateImage,
  InvokeLLM,
  SendEmail,
}
